import React, { useEffect } from 'react';
import NavBar from './Header/NavBar';
import Tabs from './Tabs/tab'
import About from './About/about';
import PaymentForm from './Payments/paymentForm';
import './app.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

function App() {
  return (
    <div className='App'>
      <BrowserRouter>
        <React.Fragment>
          <NavBar />
        </React.Fragment>
        <Routes>
          <Route path="/" element={<Tabs />} />
          <Route path="/about" element={<About />} />
          <Route path="/paymentForm" element={<PaymentForm />} />
        </Routes>
      </BrowserRouter> 
    </div>
  );
}

export default App;